import { EApiLanguageCode, EApiClozeLevel, EApiTest, EApiVocabularyBookLevel } from '@datatype/iyagigo/api-type';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
  attendance: Record<string, string>;
  // 현재학습설정
  currentStudyLanguage: EApiLanguageCode;
  currentEnglishVocabularyLevel: EApiClozeLevel;
  currentEnglishGrammarLevel: EApiClozeLevel;
  currentJapaneseVocabularyLevel: EApiClozeLevel;
  currentJapaneseGrammarLevel: EApiClozeLevel;
  currentToeicTest: EApiTest;
  currentJlptTest: EApiTest;
  currentEnglishTestVocabularyBookLevel: EApiVocabularyBookLevel;
  currentEnglishStudyVocabularyBookLevel: EApiVocabularyBookLevel;
  currentJapaneseTestVocabularyBookLevel: EApiVocabularyBookLevel;
  currentJapaneseStudyVocabularyBookLevel: EApiVocabularyBookLevel;
}

const initialState: IState = {
  attendance: {},
  // 현재학습설정
  // currentStudyLanguage: EApiLanguageCode.ENGLISH,
  currentStudyLanguage: EApiLanguageCode.JAPANESE,
  currentToeicTest: EApiTest.TOEIC750,
  currentJlptTest: EApiTest.JLPT5,
  currentEnglishVocabularyLevel: EApiClozeLevel.EASY,
  currentEnglishGrammarLevel: EApiClozeLevel.EASY,
  currentJapaneseVocabularyLevel: EApiClozeLevel.EASY,
  currentJapaneseGrammarLevel: EApiClozeLevel.EASY,
  currentEnglishTestVocabularyBookLevel: EApiVocabularyBookLevel.TOEIC550,
  currentEnglishStudyVocabularyBookLevel: EApiVocabularyBookLevel.EASY,
  currentJapaneseTestVocabularyBookLevel: EApiVocabularyBookLevel.JLPT5,
  currentJapaneseStudyVocabularyBookLevel: EApiVocabularyBookLevel.EASY,
};

const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },
    checkAttendance: (state, action: PayloadAction<{ attendanceType: string; date: string }>) => {
      state.attendance[action.payload.attendanceType] = action.payload.date;
    },
    // 현재학습설정
    storeCurrentStudyLanguage: (state, action: PayloadAction<EApiLanguageCode>) => {
      state.currentStudyLanguage = action.payload;
    },
    storeCurrentEnglishVocabularyLevel: (state, action: PayloadAction<EApiClozeLevel>) => {
      state.currentEnglishVocabularyLevel = action.payload;
    },
    storeCurrentEnglishGrammarLevel: (state, action: PayloadAction<EApiClozeLevel>) => {
      state.currentEnglishGrammarLevel = action.payload;
    },
    storeCurrentJapaneseVocabularyLevel: (state, action: PayloadAction<EApiClozeLevel>) => {
      state.currentJapaneseVocabularyLevel = action.payload;
    },
    storeCurrentJapaneseGrammarLevel: (state, action: PayloadAction<EApiClozeLevel>) => {
      state.currentJapaneseGrammarLevel = action.payload;
    },
    storeCurrentToeicTest: (state, action: PayloadAction<EApiTest>) => {
      state.currentToeicTest = action.payload;
    },
    storeCurrentJlptTest: (state, action: PayloadAction<EApiTest>) => {
      state.currentJlptTest = action.payload;
    },
    storeCurrentEnglishTestVocabularyBookLevel: (state, action: PayloadAction<EApiVocabularyBookLevel>) => {
      state.currentEnglishTestVocabularyBookLevel = action.payload;
    },
    storeCurrentEnglishStudyVocabularyBookLevel: (state, action: PayloadAction<EApiVocabularyBookLevel>) => {
      state.currentEnglishStudyVocabularyBookLevel = action.payload;
    },
    storeCurrentJapaneseTestVocabularyBookLevel: (state, action: PayloadAction<EApiVocabularyBookLevel>) => {
      state.currentJapaneseTestVocabularyBookLevel = action.payload;
    },
    storeCurrentJapaneseStudyVocabularyBookLevel: (state, action: PayloadAction<EApiVocabularyBookLevel>) => {
      state.currentJapaneseStudyVocabularyBookLevel = action.payload;
    },
  },
});

export const actions = studentSlice.actions;
export default studentSlice.reducer;
